module.exports = __webpack_public_path__ + "static/media/arauco-plus.1bc23129.svg";